import type { StaffUser } from "./api";
import { getStaffUser } from "./auth";

export const MODERATOR_HOME_PATH = "/reports";

const ADMIN_ONLY_PATH_PREFIXES = ["/audit", "/taxonomy", "/notifications", "/communities"];

export function isAdminStaff(staff: StaffUser | null | undefined): boolean {
  return staff?.role === "admin";
}

export function isModeratorStaff(staff: StaffUser | null | undefined): boolean {
  return staff?.role === "moderator" || staff?.role === "admin";
}

export function isStaffUser(staff: StaffUser | null | undefined): boolean {
  return Boolean(staff?.id);
}

export function currentUserIsAdmin(
  staff: StaffUser | null | undefined = getStaffUser(),
): boolean {
  return isAdminStaff(staff);
}

export function currentUserIsStaff(
  staff: StaffUser | null | undefined = getStaffUser(),
): boolean {
  return isStaffUser(staff);
}

export function getStaffRoleLabel(
  staff: StaffUser | null | undefined,
): "admin" | "moderator" {
  if (isAdminStaff(staff)) return "admin";
  return "moderator";
}

export function canAccessAdminPath(
  pathname: string,
  staff: StaffUser | null | undefined = getStaffUser(),
): boolean {
  if (isAdminStaff(staff)) return true;
  if (!isModeratorStaff(staff)) return false;
  return !ADMIN_ONLY_PATH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}

export function getDefaultStaffPath(staff: StaffUser | null | undefined): string {
  return isModeratorStaff(staff) && !isAdminStaff(staff)
    ? MODERATOR_HOME_PATH
    : "/";
}
